import { MedalStarIcon, ShieldTickIcon } from '@/components/dashboard/icons'
import { GcbLicenseLogo } from '@/components/layout/footer/GcbLicenseLogo'
import { ProviderStrip } from '@/components/layout/footer/ProviderStrip'

const LEGAL_LINKS = ['Terms & conditions', 'Privacy policy', 'Responsible gambling']
const SUPPORT_LINKS = ['Contact us', 'FAQ', 'Support']

export function Footer() {
	return (
		<footer className='mt-8 flex flex-col gap-8 border-t border-foreground/[0.06] pt-8'>
			<div className='flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between'>
				<p className='max-w-[497px] text-sm leading-[132%] tracking-[-0.21px] text-subtle-foreground'>
					Your trusted destination for casino, sportsbook and original games. We offer a secure, licensed platform with fair play, fast payouts and dedicated support.
				</p>

				<div className='flex flex-wrap items-center gap-8'>
					<span className='flex items-center gap-2 text-sm tracking-[-0.21px] text-muted-foreground'>
						<ShieldTickIcon className='h-[18px] w-[18px] text-primary' />
						Licensed &amp; regulated
					</span>
					<span className='flex items-center gap-2 text-sm tracking-[-0.21px] text-muted-foreground'>
						<ShieldTickIcon className='h-[18px] w-[18px] text-primary' />
						18+
					</span>
					<span className='flex items-center gap-2 text-sm tracking-[-0.21px] text-muted-foreground'>
						<MedalStarIcon className='h-[18px] w-[18px] text-primary' />
						Play responsibly
					</span>
				</div>
			</div>

			<ProviderStrip />

			<div className='flex flex-col gap-8 lg:flex-row lg:gap-16'>
				<div className='flex flex-col gap-8 sm:flex-row sm:gap-16'>
					<div className='flex flex-col gap-4'>
						<span className='text-[11px] font-medium uppercase tracking-[-0.165px] text-subtle-foreground'>Legal</span>
						<div className='flex flex-col gap-3'>
							{LEGAL_LINKS.map((link) => (
								<a key={link} href='#' className='text-sm font-medium tracking-[-0.21px] text-foreground hover:text-primary'>
									{link}
								</a>
							))}
						</div>
					</div>

					<div className='flex flex-col gap-4'>
						<span className='text-[11px] font-medium uppercase tracking-[-0.165px] text-subtle-foreground'>Support</span>
						<div className='flex flex-col gap-3'>
							{SUPPORT_LINKS.map((link) => (
								<a key={link} href='#' className='text-sm font-medium tracking-[-0.21px] text-foreground hover:text-primary'>
									{link}
								</a>
							))}
						</div>
					</div>
				</div>

				<div className='flex items-center gap-4 lg:ml-auto'>
					<GcbLicenseLogo />
					<div className='max-w-[280px] text-sm leading-[132%] tracking-[-0.21px] text-muted-foreground'>
						This site is licensed and regulated by the Gaming Control Board (GCB)
						<div className='mt-1 text-subtle-foreground'>License issued 2024.</div>
					</div>
				</div>
			</div>

			<div className='text-sm leading-[132%] tracking-[-0.21px] text-subtle-foreground'>
				We are committed to responsible gambling. You must be 18 or over to use our services. Please play responsibly.
			</div>

			<div className='mb-2 flex flex-col items-center justify-between gap-4 border-t border-border pt-6 text-sm tracking-[-0.21px] text-subtle-foreground sm:flex-row'>
				<span>&copy; 2026 All rights reserved. Licensed and secure gaming.</span>
				<span className='flex items-center gap-4'>
					<span>+18</span>
					<span>Play responsibly</span>
				</span>
			</div>
		</footer>
	)
}
